import React from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { OrganizationEntitledDagsterTransform } from 'libs/end-to-end/src/external-dagster-transforms';

export const DagsterTransformSelector = ({
  entitledTransforms,
  selectedTransformId,
  setSelectedTransformId,
  isDisabled,
}: {
  entitledTransforms: OrganizationEntitledDagsterTransform[];
  selectedTransformId: string | null;
  setSelectedTransformId: Setter<string | null>;
  isDisabled: boolean;
}) => {
  const selectedTransform = entitledTransforms.find(
    (t) => t.transformId === selectedTransformId,
  );

  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Select Dagster Transform
        </label>
        <select
          value={selectedTransformId ?? ''}
          onChange={(e) => {
            setSelectedTransformId(e.target.value || null);
          }}
          disabled={isDisabled}
          className="form-select mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          data-qa="dagsterTransformSelect"
        >
          <option value="">-- Select a transform --</option>
          {entitledTransforms.map((transform) => (
            <option key={transform.transformId} value={transform.transformId}>
              {transform.name}
            </option>
          ))}
        </select>
      </div>

      {selectedTransform && (
        <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
          <div className="text-sm">
            <div className="font-semibold text-gray-700 mb-1">
              Selected Transform
            </div>
            <div className="text-gray-600">
              <span className="font-medium">Name:</span>{' '}
              {selectedTransform.name}
            </div>
            <div className="text-gray-600 font-mono text-xs mt-1">
              <span className="font-medium font-sans">Location:</span>{' '}
              {selectedTransform.database}.{selectedTransform.schema}.
              {selectedTransform.tableName}
            </div>
          </div>
        </div>
      )}

      {entitledTransforms.length === 0 && (
        <div className="text-sm text-gray-500 italic">
          No Dagster transforms are entitled to this organization. Contact your
          administrator to grant access.
        </div>
      )}
    </div>
  );
};
